import { queryClient } from '../lib/query-client';
import { queryKeys } from '../lib/query-keys';
import { getUserDetails, getFilters, getProjectsIds, getCuratedPlaylists } from '../api/http-req';
import type { User } from '../interfaces/user';
import type { Filter } from '../interfaces/filter';
import type { CuratedPlaylist } from '../interfaces/curated-playlist';

// Cached fetchers for the order-sensitive bootstrap sequence
// (MainContent.startLoadingProcess). fetchQuery (not useQuery) preserves the
// exact imperative ordering while priming the cache so later component reads
// (e.g. useUserDetails) hit warm data. Existing store-write side effects stay
// at the call sites for now (lowest risk).

export function fetchUserDetails(): Promise<User> {
  return queryClient.fetchQuery({ queryKey: queryKeys.user.details(), queryFn: getUserDetails });
}

export function fetchFilters(): Promise<Filter[]> {
  return queryClient.fetchQuery({ queryKey: queryKeys.filters.list(), queryFn: getFilters });
}

export function fetchProjectIds(): Promise<unknown> {
  return queryClient.fetchQuery({ queryKey: queryKeys.projects.ids(), queryFn: getProjectsIds });
}

export function fetchCuratedPlaylists(): Promise<CuratedPlaylist[]> {
  return queryClient.fetchQuery({ queryKey: queryKeys.playlists.curated(), queryFn: getCuratedPlaylists });
}
